/**
 * Collection of API URL utility helpers.
 * @example
 * apiHelpers.getUrl('/users/<id>', { id: 1 });
 */
export const apiHelpers = {
  /**
   * Replaces dynamic segments in a URL template with actual values.
   *
   * @param {string} url - URL template with placeholders in `<key>` format (e.g. `"/users/<id>/cards/<cardId>"`).
   * @param {Object.<string, string|number>} params - Map of placeholder names to replacement values.
   * @returns {string} URL with all matching placeholders replaced by their values.
   * @example
   * apiHelpers.getUrl('/users/<userId>/cards/<cardId>', { userId: 42, cardId: 7 });
   * // → '/users/42/cards/7'
   */
  getUrl: (url, params) => {
    Object.keys(params).forEach(key => {
      url = url.replaceAll(`<${key}>`, params[key]);
    });
    return url;
  },
  getErrorMessage: (err) => {
    const data = err?.response?.data;
    if (!data) return err?.message;
    if (data.message) return data.message;
    if (data.error?.message) return data.error.message;
    const {detail} = data;
    if (detail) {
      if (typeof detail === 'string') return detail;
      if (Array.isArray(detail) && detail.length > 0) return detail[0].msg ?? String(detail[0]);
      if (detail.error?.message) return detail.error.message;
    }
    return err?.message;
  },
}